<template>
  <div v-if="parution">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3"> {{ getTitle }} </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button class="button" @click="$router.go(-1)">
              {{ $t('addEditParution.actions.cancel')}}
            </button>
            <button class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.sauvegarder') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <error-msg-component
      v-if="error"
      :messages="messages"
      :error="error"
      :champs-vide="champsVide"
      :messages-champs-vide="messagesChampsVide"
      @close="error = $event"
      class="mgt-20px"
      title="general.problemOccurred"
      withEmplyFields/>
    <information-general :parution="parution" :produit="produit" @setProduit="produit = $event"/>
    <pages-parution :parution="parution" :produit="produit"/>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { get, create, update } from '@/api/presse/parution';
import { get as getProduitPresse } from '@/api/produit/produitPresse';
import AppBreadcrumb from '@/components/general/breadcrumb';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import InformationGeneral from '@/components/presse/parution/edition/informationGeneral';
import PagesParution from '@/components/presse/parution/pagesParution';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import dateStringToIso from '@/services/general/dateStringToIso';
import validationGeneral from '@/services/validation/validation';
import genererParution from '@/services/presse/parution/genererParution';
import translate from '@/services/presse/parution/translatorParution';
import validationParution from '@/services/presse/parution/validationParution';
import { createNamespacedHelpers } from 'vuex';

const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    AppBreadcrumb,
    errorMsgComponent,
    InformationGeneral,
    PagesParution,
  },
  data() {
    return {
      parution: null,
      error: false,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      nomParution: null,
      produit: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    getTitle() {
      let title = this.dataAlreadyExist
        ? this.$t('addEditParution.title.edit')
        : this.$t('addEditParution.title.ajout');
      if (this.dataAlreadyExist) title += ' ' + this.nomParution;
      return title;
    },
    dataAlreadyExist() {
      return this.parution && this.parution.id !== undefined && this.parution.id !== null;
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('addEditParution.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('addEditParution.breadcrumb.liste'), route: { name: 'l.presse.parution' }, isActive: false },
        { title: this.dataAlreadyExist ? this.$i18n.t('addEditParution.breadcrumb.edit') : this.$i18n.t('addEditParution.breadcrumb.ajout'), route: { name: '' }, isActive: true },
      ];
    },
  },
  methods: {
    async save() {
      this.error = false;
      this.champsVide = [];
      this.messages = [];
      this.messagesChampsVide = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        let parution = cloneDeep(this.parution);
        parution.societeId = this.societeActiveId;
        this.preFormatParution(parution);
        if (!this.dataAlreadyExist) {
          parution = (await create(parution)).data.result;
          messageSucces(this.$i18n.t('addEditParution.notifications.successCreation'));
        } else {
          parution = (await update(parution)).data.result;
          messageSucces(this.$i18n.t('addEditParution.notifications.successChange'));
        }
        await this.$router.push({ name: 'c.presse.parution', params: { id: parution.id } });
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          validationParution(e.response, this.messages, this.$i18n, translate);
          this.error = true;
          return;
        }
        throw e;
      }
    },
    initData(data) {
      if (data.dateEnvoiCF) data.dateEnvoiCF = moment(data.dateEnvoiCF).toDate();
      if (data.dateEnvoiBAT) data.dateEnvoiBAT = moment(data.dateEnvoiBAT).toDate();
      if (data.dateRemiseEltTech) data.dateRemiseEltTech = moment(data.dateRemiseEltTech).toDate();
      if (data.dateParution) data.dateParution = moment(data.dateParution).toDate();
      data.pages.forEach(page => { page.selected = false; });
      return cloneDeep(data);
    },
    preFormatParution(data) {
      if (data.dateEnvoiCF) data.dateEnvoiCF = dateStringToIso(data.dateEnvoiCF);
      if (data.dateEnvoiBAT) data.dateEnvoiBAT = dateStringToIso(data.dateEnvoiBAT);
      if (data.dateRemiseEltTech) data.dateRemiseEltTech = dateStringToIso(data.dateRemiseEltTech);
      if (data.dateParution) data.dateParution = dateStringToIso(data.dateParution);
      data.pages.forEach((page) => {
        if (!page.isCreate) return;
        delete page.isCreate;
        delete page.id;
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      let parution = genererParution();
      if (this.$route.params.id) {
        parution = (await get(this.$route.params.id)).data.result;
        this.produit = (await getProduitPresse(parution.produitId)).data.result;
        this.nomParution = parution.nomParution;
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.nomParution }));
      } else {
        if (this.$route.params.produitId) {
          this.produit = (await getProduitPresse(this.$route.params.produitId)).data.result;
        }
        this.setInformationPage(this.$t('pagePresse.parution.creation'));
      }
      this.parution = this.initData(parution);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
